import React from "react";
import LeftAboutSection2 from "../About/section2/section2Left/LeftAboutSection2";
import RightAboutSection2 from "../About/section2/section2Right/RightAboutSection2";
import Parallax2 from "../common/parallax/Parallax2";
import ServiceSection1 from "./section1/ServiceSection1";
import ServiceSection3 from "./section3/ServiceSection3";
import UniformServiceSection4 from "./section4/UniformServiceSection4";
// import ServiceSection2 from './section2/ServiceSection2'

const Service = () => {
  return (
    <div className="w-screen">
      <Parallax2 heading="SERVICE" subHeading="OUR SERVICES" />
      <ServiceSection1 />
      <ServiceSection3 />
      <div className=" lg:mx-28 mx-2 lg:flex ">
        <LeftAboutSection2 />

        <RightAboutSection2 />
      </div>
      <UniformServiceSection4 />
    </div>
  );
};

export default Service;
